import { atom } from "recoil";

export const tableDescriptionAtom = atom({
  key: "tableDescription",
  default: null as string | null,
});

/**
 * When atom changes, trigger query of unmapped apis for
 * unmapped menu badges and for unmapped filter
 */
export const triggerUnmappeQueryAtom = atom({
  key: "triggerUnmappeQueryAtom",
  default: false,
});
